<template>
  <div id="paginaCostoProduzioni">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Mostra Oneri Personale</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-datepicker
                  id="dataInizio" v-model="dataInizio" start="Decade" depth="Year"
                  :format="settings.formatoMese" placeholder="Inizio" />
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-datepicker
                  id="dataFine" v-model="dataFine" start="Decade" depth="Year"
                  :format="settings.formatoMese" placeholder="Fine" />
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-button id="cercaIntervallo" @click.native="ricerca()" >
                  Trova
                </ejs-button>
                <ejs-button id="exportXls" @click.native="exportXls()" >
                  Esporta XLS
                </ejs-button>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="oneriFullData" :allowSorting="true"
                    :height="gridA.height" width="100%" :allowFiltering="true" locale="it-IT"
                    :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions">
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="100"></e-column>
                      <e-column field="nomeMese" headerText="Mese" width="150"></e-column>
                      <e-column field="cfsoggetto" headerText="Cod. Fiscale" width="200"></e-column>
                      <e-column field="denominazioneSoggetto" headerText="Denominazione" width="200"></e-column>
                      <e-column field="titoloSpettacolo" headerText="Titolo Spettacolo" width="250"></e-column>
                      <e-column field="data_assunzione" headerText="Assunzione" width="200" :format="settings.formatoData" type="date" ></e-column>
                      <e-column field="data_cessazione" headerText="Cessazione" width="200" :format="settings.formatoData" type="date" ></e-column>
                      <e-column field="costo_retribuzione" headerText="Costo Retribuzione" width="200" format="C2"></e-column>
                      <e-column field="costo_contributivo" headerText="Costo Contributivo" width="200" format="C2"></e-column>
                      <e-column field="costo_inail" headerText="Costo INAIL" width="200" format="C2"></e-column>
                      <e-column field="oneri_carico_ditta" headerText="Oneri Carico Ditta" width="200" format="C2"></e-column>
                      <e-column field="rivalsa" headerText="Rivalsa" width="200" format="C2"></e-column>
                      <e-column field="totale_oneri" headerText="Totale Oneri" width="200" format="C2"></e-column>
                      <e-column field="costo_rimborsi_trasferte" headerText="Costo Rimborsi Trasferte" width="200" format="C2"></e-column>
                      <e-column field="gg" headerText="Giorni" width="150"></e-column>
                    </e-columns>
                    <e-aggregates>
                      <e-aggregate>
                        <e-columns>
                          <e-column type="Sum" field="costo_retribuzione" format="Tot € ######.##"></e-column>
                          <e-column type="Sum" field="costo_contributivo" format="Tot € ######.##"></e-column>
                        </e-columns>
                      </e-aggregate>
                    </e-aggregates>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, LinkPlugin, AlertPlugin, ProgressPlugin,
  ToastPlugin, SpinnerPlugin,
} from 'bootstrap-vue'
// import Vuexy
// import Syncfusion

import { enableRipple, setCulture, L10n, setCurrencyCode } from '@syncfusion/ej2-base'
//import { Query } from '@syncfusion/ej2-data'
import {
  TextBoxPlugin, NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs'
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import {
  DropDownListPlugin,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Toolbar, ExcelExport,
  Aggregate, Sort
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

L10n.load({
  'it-IT': {
    'grid': {
      'ConfirmDelete': 'Sei sicuro di cancellare? Clicca OK per confermare la cancellazione, CANCEL per annullare'
    },
    'calendar': { today: 'oggi' } // per cambiare la lingua nei calendar e data occorre qualche passaggio in più (https://ej2.syncfusion.com/vue/documentation/calendar/globalization)
  }
});

const axios = require('axios')
// use bootstrap-vue
Vue.use(LayoutPlugin)
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(SpinnerPlugin)
// use Syncfusion
Vue.use(DatePickerPlugin)
Vue.use(ButtonPlugin)
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(DropDownListPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
enableRipple(true)
// api
const apiOneriAnnoUrl = '/demo/api/oneri/ricercaAnno'
const apiOneriIntervalloUrl = '/demo/api/oneri/ricercaIntervallo'
const apiOneriExportUrl = '/demo/api/oneri/exportXls'
// setCulture('it')
setCurrencyCode('EUR')

export default Vue.extend({
  components: {
  },
  data() {
    return {
      loading: false,
      // per gestione stagioni
      mesi: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
             "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      stagioniFields: { value: "val", text: "label" },
      stagioniIndex: -1,
      queryStagioni: null,
      stagioneCorrente: null,
      dataInizio: new Date(),
      dataFine: new Date(),
      // gestione elementi nascosti
      nonMostrare: false,
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        formatoMese: "MMMM yyyy", // da usare per i datepicker
      },
      // costoProduzioni
      oneriFullData: [], // elenco completo dati costoProduzioni

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: false,
        },
        filterOptions: { type: 'Excel' },
      }, //
    }
  },
  created() {
    // log
    console.log('Pagina Mostra Oneri Personale Creata')
  },
  mounted() {
    // disabilito gridA
    // this.$refs.gridA.$el.classList.add('disablegrid')
    // document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropStagioni
    // this.$refs.dropStagioni.ej2Instances.focusIn()
  },

  provide: {
    grid: [Toolbar, ExcelExport, Aggregate, Sort],
  },
  methods: {
    roundNumber: function(val) {
      return Math.round(val * 100) / 100;
    },
    ricerca: function(args) {
      console.log(this.dataInizio)
      console.log(this.dataFine)
      const datiDaInviare = {
        dataInizio: this.dataInizio,
        dataFine: this.dataFine,
      };
      useJwt.post(apiOneriIntervalloUrl, datiDaInviare).then((d) => {
        // gestione risposta
        // console.log("RISPOSTA BACKEND")
        // console.log(d.data)
        this.oneriFullData = d.data

        this.oneriFullData.forEach((obj) => {
          const d = new Date(obj['mese'])
          obj['nomeMese'] = this.mesi[d.getMonth()];
          // console.log(obj['nomeMese']);
        })
      })
    },
    exportXls: function(args) {
      const datiDaInviare = {
        dataInizio: this.dataInizio,
        dataFine: this.dataFine,
      };

      useJwt.post(apiOneriExportUrl, datiDaInviare, { responseType: "blob" }).then((r) => {
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore nel download")
      });
    },
    
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    noop() {
      console.log("premuto enter")
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-schedule/styles/material.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
